export class Animations {
    static getHeight(element) {
        let style = window.getComputedStyle(element), display = style.display, position = style.position, visibility = style.visibility, wanted_height = 0;
        // if its not hidden we just return normal height
        if (element.visible()) {
            return element.offsetHeight;
        }
        // the element is hidden so:
        // making the el block so we can meassure its height but still be hidden
        element.style.position = 'absolute';
        element.style.visibility = 'hidden';
        element.style.display = 'block';
        wanted_height = element.offsetHeight;
        // reverting to the original values
        element.style.display = display;
        element.style.position = position;
        element.style.visibility = visibility;
        return wanted_height;
    }
    static slide(element, dir = "up", duration, easing) {
        duration = duration || 0.5;
        easing = easing || "ease-in-out";
        if (element.getAttribute("data-max-height")) {
            let max_height = element.getAttribute("data-max-height");
            max_height = dir == "up" ? "0" : max_height;
            element.style.maxHeight = max_height;
        }
        else {
            let max_height = Animations.getHeight(element) + "px";
            let from = dir == "up" ? max_height : "0";
            let to = dir == "up" ? "0" : max_height;
            element.setAttribute("data-max-height", max_height);
            element.style["transition"] = "max-height " + duration + "s " + easing;
            element.style.overflowY = "hidden";
            element.style.maxHeight = from;
            element.style.display = "block";
            // we use setTimeout to modify maxHeight later than display (to we have the transition effect)
            setTimeout(() => {
                element.style.maxHeight = to;
            }, 10);
        }
    }
    static slideUp(element, duration, easing) {
        Animations.slide(element, "up", duration, easing);
    }
    static slideDown(element, duration, easing) {
        Animations.slide(element, "down", duration, easing);
    }
    static slideToggle(element, duration, easing) {
        let visible = false;
        if (element.getAttribute("data-max-height")) {
            visible = element.style.maxHeight.replace("px", "").replace("%", "") !== "0";
        }
        else {
            visible = element.visible();
        }
        if (visible) {
            Animations.slide(element, "up", duration, easing);
        }
        else {
            Animations.slide(element, "down", duration, easing);
        }
    }
}
